import React from 'react';
import { show } from '@shopee/chatbot-ui/lib/components/Modal/show';
import { getTrans } from '@/utils/tools';

export function showBankUpdateModal() {
  show({
    active: true,
    type: 'modal',
    onClose: () => {},
    title: getTrans('popup_title_new_update'),
    children: (
      <div>
        {getTrans('popup_desc_new_update')}
      </div>
    ),
    showCloseButton: true,
    closeButtonText: getTrans('btn_ok'),
    className: 'ChatbotUI-bank-update-modal',
  });
}
